/**
 * OnlyPlanks cart shipping calculator v2 (live theme).
 * Bands by REAL cart weight (grams). Thresholds = 50/100 m² of 6.5mm Hybrid (Eclipse).
 * Rates: zone Rate A per pallet up to BAND_B (2× removed 17 Oct 2026); Alice Collect-only; WA flagged.
 * 26 Sep 2026: Collect line lists nearest supplier hub per vendor (window.OP_PICKUP_HUBS, assets/op-pickup-hubs.js).
 */
(function () {
  'use strict';

  var DATA = window.OP_SHIP_DATA || {};
  var RATE_A = DATA.rateA || { Z1: 250, Z2: 290, Z3: 365, Z6: 575, Z8: 745, Z9: 820 };
  var BOX = DATA.boxM2ByHandle || {};
  var BAND_A = DATA.bandAMaxKg || 536.062;
  var BAND_B = DATA.bandBMaxKg || 1072.125;
  var EMAIL = DATA.contactEmail || 'contactus@onlyplanks.com.au';
  var STORAGE_KEY = 'op_ship_postcode';

  function classify(pc) {
    pc = String(pc || '').replace(/\D/g, '');
    if (pc.length !== 4) return null;
    var n = parseInt(pc, 10);
    // WA (6xxx) + NT (08xx/09xx): not sold or delivered (Richard, 25 Sep 2026)
    // TAS (7xxx): not sold or delivered (Richard, 26 Sep 2026)
    if ((n >= 6000 && n <= 6999) || (n >= 800 && n <= 999) || (n >= 7000 && n <= 7999)) {
      return { zone: 'NOSALE', policy: 'NO_SALE', note: 'WA / NT / TAS — not serviced' };
    }
    if (n >= 5000 && n <= 5199) {
      return { zone: 'Z3', policy: 'DOOR', note: 'Adelaide metro' };
    }
    if (n >= 2470 && n <= 2490) {
      return { zone: 'Z6', policy: 'DOOR', note: 'Far north NSW / Byron' };
    }
    if ((n >= 4207 && n <= 4230) || (n >= 4280 && n <= 4299)) {
      return { zone: 'Z2', policy: 'DOOR', note: 'Gold Coast' };
    }
    if (
      (n >= 4000 && n <= 4206) ||
      (n >= 4300 && n <= 4306) ||
      (n >= 4110 && n <= 4133) ||
      (n >= 4157 && n <= 4184) ||
      (n >= 4500 && n <= 4521)
    ) {
      return { zone: 'Z1', policy: 'DOOR', note: 'Brisbane / SEQ' };
    }
    if (
      (n >= 3000 && n <= 3211) ||
      (n >= 3335 && n <= 3341) ||
      (n >= 3427 && n <= 3443) ||
      (n >= 3750 && n <= 3815) ||
      (n >= 3910 && n <= 3920) ||
      (n >= 3930 && n <= 3984) ||
      (n >= 8000 && n <= 8099)
    ) {
      return { zone: 'Z1', policy: 'DOOR', note: 'Melbourne metro' };
    }
    if (
      (n >= 1000 && n <= 2249) ||
      (n >= 2555 && n <= 2574) ||
      (n >= 2745 && n <= 2786)
    ) {
      return { zone: 'Z2', policy: 'DOOR', note: 'Sydney metro' };
    }
    if (n >= 4700 && n <= 4709) {
      return { zone: 'Z8', policy: 'DOOR', note: 'Rockhampton class' };
    }
    if (n >= 800 && n <= 899) {
      return { zone: 'Z9', policy: 'DOOR', note: 'NT / top-end' };
    }
    return { zone: 'Z9', policy: 'DOOR', note: 'Rest of AU' };
  }

  function handleFromUrl(url) {
    if (!url) return '';
    var m = String(url).match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  function money(n) {
    return '$' + Number(n).toLocaleString('en-AU', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }

  // --- Collect hubs (26 Sep 2026): nearest supplier warehouse per vendor, suburb only ---
  var DOOR_ETA = 'arrives 5–12 business days after payment';
  var PICKUP_NOTE = 'Usually ready within the same week · collection from 8am · address and order number emailed after payment · your installer can collect';
  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function hubFor(vendor, pc) {
    var H = window.OP_PICKUP_HUBS;
    var v = H && H.vendors && H.vendors[vendor];
    if (!v || !v.runs || !v.runs.length) return null;
    var n = parseInt(pc, 10);
    var lo = 0, hi = v.runs.length - 1, idx = 0;
    while (lo <= hi) {
      var mid = (lo + hi) >> 1;
      if (v.runs[mid][0] <= n) { idx = mid; lo = mid + 1; } else { hi = mid - 1; }
    }
    return v.hubs[v.runs[idx][1]] || null;
  }
  function pickupHtml(parts, pc) {
    if (!parts || !parts.length) return '';
    var seen = {}, lines = [], trims = false, samples = false;
    parts.forEach(function (p) {
      var vendor = p.vendor || '';
      var type = String(p.type || '').toLowerCase();
      if (vendor === 'OnlyPlanks') {
        if (type === 'trim') trims = true;
        else if (type === 'sample') samples = true;
        return;
      }
      if (seen[vendor]) return;
      seen[vendor] = 1;
      var h = hubFor(vendor, pc);
      if (h) lines.push('<strong>Collect free</strong> ($0): ' + esc(vendor) + ' warehouse, ' + esc(h.address || (h.suburb + ' ' + h.state)) + (h.hours ? '<br><span class="op-ship-calc__hours">' + esc(h.hours) + '</span>' : ''));
      else lines.push(esc(vendor) + ': no pickup depot listed for this brand. Door delivery, or email us to arrange collection.');
    });
    if (trims && lines.length) lines.push('Trims: pickup with your floor');
    if (!lines.length && !samples) return '';
    var html = '<div class="op-ship-calc__pickup">';
    lines.forEach(function (l) { html += '<p class="op-ship-calc__pickup-line">' + l + '</p>'; });
    if (lines.length) html += '<p class="op-ship-calc__pickup-note">' + PICKUP_NOTE + '</p>';
    if (samples) html += '<p class="op-ship-calc__pickup-note">Samples are posted to you, not collected.</p>';
    return html + '</div>';
  }

  function cartTotals(cart) {
    var m2 = 0;
    var kg = 0;
    var freightQuote = false;
    var FQ = DATA.freightQuoteHandles || [];
    var samples = 0;
    var others = 0;
    (cart.items || []).forEach(function (item) {
      var handle = item.handle || handleFromUrl(item.url);
      // Samples are posted by AusPost with postage included in the pack price: no pallet freight, no weight bands
      if (handle === 'flooring-samples' || String(item.product_type || '').toLowerCase() === 'sample') {
        samples += item.quantity || 0;
        return;
      }
      others += item.quantity || 0;
      var box = BOX[handle];
      var qty = item.quantity || 0;
      if (box != null && box > 0) m2 += box * qty;
      var grams = item.grams || 0;
      kg += (grams * qty) / 1000;
      if (handle && FQ.indexOf(handle) !== -1) freightQuote = true;
    });
    return { m2: m2, kg: kg, freightQuote: freightQuote, samples: samples, onlySamples: samples > 0 && others === 0 };
  }

  function quote(totals, zoneInfo) {
    var collect = { label: 'Collect free', price: 0, show: true };
    var m2 = totals.m2;
    var kg = totals.kg;
    if (!zoneInfo) {
      return { collect: collect, door: null, message: null, band: null };
    }
    if (zoneInfo.policy === 'NO_SALE') {
      return {
        collect: null,
        door: null,
        noSale: true,
        message: 'Sorry, we don\'t offer door delivery to WA, NT or TAS. Please email us at ' + EMAIL + ' and we\'ll see what we can do.',
        band: null,
        zone: zoneInfo.zone,
      };
    }
    if (totals.onlySamples) {
      return {
        collect: null,
        door: null,
        samplesOnly: true,
        message: 'Samples are posted to you (AusPost) and the pack price already includes postage. There is no freight to pay for samples.',
        band: null,
        zone: zoneInfo.zone,
      };
    }
    if (totals.freightQuote) {
      return {
        collect: collect,
        door: null,
        message: 'Please contact us for a freight cost. Collect free is always available.',
        band: 'QUOTE',
        zone: zoneInfo.zone,
        m2: m2,
        kg: kg,
        freightQuote: true,
      };
    }
    if (zoneInfo.policy === 'COLLECT_ONLY') {
      return {
        collect: collect,
        door: null,
        message: 'Door delivery is not available online for this postcode. Collect free, or contact us for a custom quote.',
        band: null,
        zone: zoneInfo.zone,
        m2: m2,
        kg: kg,
      };
    }
    if (zoneInfo.policy === 'WA_REVIEW') {
      return {
        collect: collect,
        door: null,
        message: 'WA door delivery depends on stock location. Collect free is always available — contact us to confirm if door is possible for your order.',
        band: null,
        zone: zoneInfo.zone,
        wa: true,
        m2: m2,
        kg: kg,
      };
    }
    if (!(kg > 0) && !(m2 > 0)) {
      return { collect: collect, door: null, message: 'Add flooring boxes to see door rates.', band: null, zone: zoneInfo.zone };
    }
    // Band by REAL kg (6.5mm Hybrid reference thresholds)
    if (kg > BAND_B) {
      return {
        collect: collect,
        door: null,
        message: 'Please contact us direct for a shipping quote due to order size/weight.',
        band: 'OVER',
        zone: zoneInfo.zone,
        m2: m2,
        kg: kg,
      };
    }
    var rateA = RATE_A[zoneInfo.zone];
    if (rateA == null) {
      return { collect: collect, door: null, message: 'Contact us for a shipping quote.', band: null, zone: zoneInfo.zone, m2: m2, kg: kg };
    }
    // 17 Oct 2026: one pallet up to BAND_B = one zone rate (fixes half-pallet double charge; matches op-freight-rates)
    var mult = 1;
    var door = rateA;
    return {
      collect: collect,
      door: {
        label: 'Door delivery (1 pallet)',
        price: door,
        rateA: rateA,
        mult: mult,
      },
      message: null,
      band: kg <= BAND_A ? 'A' : 'B',
      zone: zoneInfo.zone,
      m2: m2,
      kg: kg,
    };
  }

  function totalsHasSamples(t) { return !!(t && t.samples > 0 && !t.onlySamples); }

  function render(root, q, totals, pc, vendorParts) {
    var results = root.querySelector('[data-op-ship-results]');
    var m2El = root.querySelector('[data-op-ship-m2]');
    if (m2El) {
      var parts = [];
      if (totals.m2 > 0) parts.push(totals.m2.toFixed(2) + ' m²');
      if (totals.kg > 0) parts.push(totals.kg.toFixed(1) + ' kg');
      if (totals.samples > 0) parts.push(totals.samples + (totals.samples === 1 ? ' sample' : ' samples') + ' (postage included)');
      m2El.textContent = parts.length ? parts.join(' · ') + ' in cart' : 'No flooring in cart yet';
    }
    if (!results) return;
    if (!pc || pc.length !== 4) {
      results.innerHTML = '<p class="op-ship-calc__hint op-ship-calc__hint--err" role="alert">Please enter your 4-digit postcode (for example 4212), then tap Get rates.</p>';
      return;
    }
    if (q.samplesOnly) {
      results.innerHTML = '<p class="op-ship-calc__msg">' + q.message + '</p>';
      return;
    }
    var html = '';
    html += '<ul class="op-ship-calc__options" role="list">';
    if (!q.noSale) {
      html += '<li class="op-ship-calc__opt op-ship-calc__opt--collect"><span class="op-ship-calc__opt-label">Collect free from the nearest warehouse <span class="op-ship-calc__eta">usually ready the same week</span></span><span class="op-ship-calc__opt-price">$0</span></li>';
    }
    if (q.door) {
      html +=
        '<li class="op-ship-calc__opt op-ship-calc__opt--door"><span class="op-ship-calc__opt-label">' +
        q.door.label +
        ' <span class="op-ship-calc__eta">inc GST · usually ' + DOOR_ETA + '</span></span><span class="op-ship-calc__opt-price">' +
        money(q.door.price) +
        '</span></li>';
    }
    html += '</ul>';
    if (!q.noSale) html += pickupHtml(vendorParts, pc);
    if (totalsHasSamples(totals)) {
      html += '<p class="op-ship-calc__pickup-note">Samples in your cart are posted separately with postage included. Freight above is for your flooring boxes only.</p>';
    }
    if (q.message) {
      html += '<p class="op-ship-calc__msg">' + q.message;
      if (q.band === 'OVER' || q.band === 'QUOTE' || q.wa || (q.zone === 'POA') || q.freightQuote) {
        html += ' <a href="mailto:' + EMAIL + '">' + EMAIL + '</a>';
      }
      html += '</p>';
    }
    if (q.door && q.kg != null) {
      html +=
        '<p class="op-ship-calc__detail">' +
        (q.m2 ? q.m2.toFixed(1) + ' m² · ' : '') +
        (q.kg < 10 ? q.kg.toFixed(1) : q.kg.toFixed(0)) +
        ' kg to postcode ' +
        pc +
        ' = door ' +
        money(q.door.price) +
        ' inc GST · or Collect free $0. Checkout charges the same.</p>';
    }
    results.innerHTML = html;
  }

  function bind(root) {
    if (!root || root.getAttribute('data-op-bound') === '1') return;
    root.setAttribute('data-op-bound', '1');
    var input = root.querySelector('[data-op-ship-postcode]');
    var btn = root.querySelector('[data-op-ship-go]');
    var lastCart = null;
    var mode = root.getAttribute('data-op-ship-mode') || 'cart';

    function qtyFromPdp() {
      var q = 1;
      var el =
        document.querySelector('quantity-input input, input[name="quantity"], .quantity__input, input[name="updates[]"]') ||
        document.querySelector('form[action*="/cart/add"] input[name="quantity"]');
      if (el && el.value) q = parseInt(el.value, 10) || 1;
      return Math.max(1, q);
    }

    function boxKgFromPdp() {
      var kg = parseFloat(root.getAttribute('data-op-box-kg') || '0') || 0;
      // Prefer selected variant weight from Shopify analytics / JSON if present
      try {
        var sel = document.querySelector('variant-selects [data-option], variant-picker input:checked, input[name="id"]');
        var idEl = document.querySelector('form[action*="/cart/add"] [name="id"], input[name="id"]');
        var vid = idEl && idEl.value;
        if (vid && window.meta && window.meta.product && window.meta.product.variants) {
          var v = window.meta.product.variants.find(function (x) { return String(x.id) === String(vid); });
          if (v && v.weight) {
            // Shopify meta weight is often grams
            var w = Number(v.weight);
            if (w > 100) kg = w / 1000;
            else if (w > 0) kg = w;
          }
        }
      } catch (e) {}
      return kg;
    }

    function pdpTotals() {
      var qty = qtyFromPdp();
      var kgEach = boxKgFromPdp();
      var handle = root.getAttribute('data-op-product-handle') || '';
      var box = BOX[handle];
      var m2 = box != null && box > 0 ? box * qty : 0;
      return { m2: m2, kg: kgEach * qty, freightQuote: false, qty: qty };
    }

    function run() {
      input = root.querySelector('[data-op-ship-postcode]'); btn = root.querySelector('[data-op-ship-go]');
      var pc = (input && input.value ? input.value : '').replace(/\D/g, '').slice(0, 4);
      if (input) input.value = pc;
      try {
        if (pc.length === 4) localStorage.setItem(STORAGE_KEY, pc);
      } catch (e) {}
      var zoneInfo = pc.length === 4 ? classify(pc) : null;
      var totals = mode === 'pdp' ? pdpTotals() : cartTotals(lastCart || { items: [] });
      var q = quote(totals, zoneInfo);
      var parts = mode === 'pdp'
        ? [{ vendor: root.getAttribute('data-op-product-vendor') || '', type: root.getAttribute('data-op-product-type') || '' }]
        : ((lastCart && lastCart.items) || []).map(function (it) { return { vendor: it.vendor, type: it.product_type }; });
      render(root, q, totals, pc, parts);
      if (mode === 'pdp' && m2ElFix(root, totals)) {}
    }

    function m2ElFix(root, totals) {
      var m2El = root.querySelector('[data-op-ship-m2]');
      if (!m2El || mode !== 'pdp') return false;
      var parts = [];
      if (totals.qty) parts.push(totals.qty + (totals.qty === 1 ? ' box' : ' boxes'));
      if (totals.m2 > 0) parts.push(totals.m2.toFixed(2) + ' m²');
      if (totals.kg > 0) parts.push(totals.kg.toFixed(1) + ' kg');
      m2El.textContent = parts.length ? parts.join(' · ') + ' selected' : 'Select a box quantity';
      return true;
    }

    var statusEl = null;
    function status(text, kind) {
      if (!statusEl || !statusEl.isConnected) {
        statusEl = document.createElement('p');
        statusEl.className = 'op-ship-calc__status';
        statusEl.setAttribute('role', 'status');
        statusEl.setAttribute('aria-live', 'polite');
        var results = root.querySelector('[data-op-ship-results]');
        if (results && results.parentNode) results.parentNode.insertBefore(statusEl, results);
      }
      statusEl.textContent = text || '';
      statusEl.className = 'op-ship-calc__status' + (kind ? ' op-ship-calc__status--' + kind : '');
    }

    function finish(manual) {
      input = root.querySelector('[data-op-ship-postcode]'); btn = root.querySelector('[data-op-ship-go]');
      var pc = (input && input.value ? input.value : '').replace(/\D/g, '');
      var results = root.querySelector('[data-op-ship-results]');
      if (btn) { btn.disabled = false; btn.textContent = 'Get rates'; btn.removeAttribute('aria-busy'); }
      if (pc.length === 4) {
        if (input) input.removeAttribute('aria-invalid');
        status('Rates updated for postcode ' + pc + '.', 'ok');
      } else if (manual) {
        status('', '');
        if (input) { input.setAttribute('aria-invalid', 'true'); try { input.focus(); } catch (e) {} }
      }
      if (manual && results) {
        results.classList.remove('op-ship-calc__results--flash');
        void results.offsetWidth;
        results.classList.add('op-ship-calc__results--flash');
        try { results.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) {}
      }
    }

    function loadCart(manual) {
      manual = manual === true;
      input = root.querySelector('[data-op-ship-postcode]'); btn = root.querySelector('[data-op-ship-go]');
      if (manual && btn) {
        btn.disabled = true;
        btn.textContent = 'Checking…';
        btn.setAttribute('aria-busy', 'true');
        status('Checking rates…', 'info');
      }
      if (mode === 'pdp') {
        run();
        if (manual) setTimeout(function () { finish(true); }, 250);
        else finish(false);
        return Promise.resolve();
      }
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          lastCart = cart;
          run();
        })
        .catch(function () {
          lastCart = { items: [] };
          run();
        })
        .then(function () {
          if (manual) setTimeout(function () { finish(true); }, 250);
          else finish(false);
        });
    }

    // Exposed for the delegated click/enter handlers below (survive drawer re-renders)
    root.__opShipGo = function () { return loadCart(true); };

    if (input) {
      input.addEventListener('input', function () {
        var pc = input.value.replace(/\D/g, '').slice(0, 4);
        if (input.value !== pc) input.value = pc;
        if (pc.length === 4) loadCart(false);
      });
      try {
        var saved = localStorage.getItem(STORAGE_KEY);
        if (saved && /^\d{4}$/.test(saved)) input.value = saved;
      } catch (e) {}
    }

    if (mode === 'pdp') {
      document.addEventListener('change', function (e) {
        var t = e.target;
        if (!t) return;
        if (t.name === 'quantity' || t.name === 'id' || (t.closest && t.closest('quantity-input, variant-selects, variant-picker'))) {
          run();
        }
      });
      document.addEventListener('input', function (e) {
        var t = e.target;
        if (t && (t.name === 'quantity' || (t.classList && t.classList.contains('quantity__input')))) run();
      });
    } else {
      document.addEventListener('cart:updated', function () { loadCart(false); });
      document.addEventListener('cart:change', function () { loadCart(false); });
      document.addEventListener('shopify:cart:change', function () { loadCart(false); });
    }
    loadCart(false);
  }

  // Delegated, capture-phase handlers: Get rates + Enter keep working even if the cart drawer re-renders
  // or another script stops propagation (SimGym 4 Oct 2026: "Get rates unresponsive").
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-op-ship-go]') : null;
    if (!b) return;
    var root = b.closest('[data-op-ship-calc]');
    if (!root) return;
    e.preventDefault();
    e.stopPropagation();
    if (!root.__opShipGo) bind(root);
    if (root.__opShipGo) root.__opShipGo();
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var t = e.target;
    if (!t || !t.closest || !t.matches || !t.matches('[data-op-ship-postcode]')) return;
    var root = t.closest('[data-op-ship-calc]');
    if (!root) return;
    e.preventDefault();
    if (!root.__opShipGo) bind(root);
    if (root.__opShipGo) root.__opShipGo();
  }, true);

  function boot() {
    document.querySelectorAll('[data-op-ship-calc]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  var mo = new MutationObserver(function () { boot(); });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
